import * as Sentry from "@sentry/react";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { cn } from "~/components/ui/cn";
import { CopyIcon } from "~/components/ui/icons/copy";
import { toast } from "~/components/ui/toast";
import { useCopyToClipboard } from "~/hooks/use-copy-to-clipboard";
import { track } from "~/libs/analytics";

type SetupContactCopyButtonProps = {
  className?: string;
  email: string;
  from: string;
};

export const SetupContactCopyButton: React.FC<SetupContactCopyButtonProps> = ({
  className,
  email,
  from,
}) => {
  const { t } = useTranslation();
  const [emailClipboardState, copyEmailToClipboard] = useCopyToClipboard();

  useEffect(() => {
    const { value, error } = emailClipboardState;
    if (value) {
      toast.success(t("clipboard.email_copied"));
    }
    if (error) {
      Sentry.captureException(error);
    }
  }, [emailClipboardState, t]);

  return (
    <button
      onClick={() => {
        copyEmailToClipboard(email);
        track("CopyToClipboard", {
          label: "am_contact_email",
          from: from,
        });
      }}
      type="button"
      className={cn(
        "flex place-content-center items-center justify-start text-xs font-semibold text-green-900",
        className,
      )}
    >
      <span>{email}</span>
      <CopyIcon className="ml-1 size-3.5" />
    </button>
  );
};
